
namespace Gamification.Gamification {
    export class ProdottiEsperienzeTaskColumns {
        static columnsKey = 'Gamification.ProdottiEsperienzeTask';
    }
}